import React from "react";
import { useNavigate } from "react-router-dom";
import { BranchEmployeeSummary } from "../../../types/admin";

interface EmployeeTabProps {
  employees: BranchEmployeeSummary[];
}

const EmployeeTab: React.FC<EmployeeTabProps> = ({ employees }) => {
  const navigate = useNavigate();
  return (
    <div className="table-shell mt-4" style={{ overflowX: 'auto' }}>
      <table className="admin-table compact" style={{ whiteSpace: 'nowrap' }}>
        <thead>
          <tr>
            <th>직원번호</th>
            <th>이름</th>
            <th>가입여부</th>
            <th>연락처</th>
            <th>상태</th>
            <th>입사일</th>
            <th>퇴사일</th>
            <th style={{ textAlign: 'center' }}>상세</th>
            <th style={{ textAlign: 'center' }}>계약서</th>
            <th style={{ textAlign: 'center' }}>급여명세서</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((employee) => (
            <tr key={employee.employee_id}>
              <td>{employee.employee_number}</td>
              <td>{employee.employee_name}</td>
              <td>
                <span className={`branch-status-badge ${employee.is_guest ?? (employee.linked_user_id === null) ? 'branch-status-badge--neutral' : 'branch-status-badge--operating'}`}>
                  {employee.is_guest ?? (employee.linked_user_id === null) ? '비회원' : '회원'}
                </span>
              </td>
              <td>{employee.phone_number}</td>
              <td>{employee.employment_status_label}</td>
              <td>{employee.hire_date || "-"}</td>
              <td>{employee.resignation_date || "-"}</td>
              <td style={{ textAlign: 'center' }}>
                <button
                  className="detail-icon-btn"
                  type="button"
                  style={{ padding: '4px 8px', fontSize: '12px', whiteSpace: 'nowrap' }}
                  onClick={() => navigate(`/admin/employees/${employee.employee_id}`)}
                >
                  상세
                </button>
              </td>
              <td style={{ textAlign: 'center' }}>
                <button
                  className="detail-icon-btn"
                  type="button"
                  style={{ padding: '4px 8px', fontSize: '12px', whiteSpace: 'nowrap', backgroundColor: '#f0f5ff', color: '#5696ff', border: '1px solid #5696ff' }}
                  onClick={() => navigate(`/admin/employees/${employee.employee_id}/contracts`)}
                >
                  계약서
                </button>
              </td>
              <td style={{ textAlign: 'center' }}>
                <button
                  className="detail-icon-btn"
                  type="button"
                  style={{ padding: '4px 8px', fontSize: '12px', whiteSpace: 'nowrap', backgroundColor: '#f0f5ff', color: '#5696ff', border: '1px solid #5696ff' }}
                  onClick={() => navigate(`/admin/employees/${employee.employee_id}/payrolls`)}
                >
                  급여명세서
                </button>
              </td>
            </tr>
          ))}
          {employees.length === 0 && (
            <tr>
              <td className="empty-row" colSpan={10}>
                등록된 직원이 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeTab;
